import { EventBus } from '../../helpers';

type CurrencyEvents = {
  currencyIsChanging: [isChanging: boolean];
  currencyHasChanged: [currency: string];
};

class CurrencyEventBus extends EventBus<CurrencyEvents> {}

export const currencyEventBus = new CurrencyEventBus();
